import React, { useState } from "react";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { Box } from "@mui/system";
import { blue, green, grey, red } from "@mui/material/colors";
import axios from "axios";
import Snackbar from "../../UI/Snackbar";
import { createChatSocket } from "../../utils/chatSocket";

const strt = { backgroundColor: grey[500], color: "white", fontSize: "1rem" };
const wait = { backgroundColor: green[500], color: "white", fontSize: "1rem" };
const move = { backgroundColor: blue[500], color: "white", fontSize: "1rem" };
const actv = { backgroundColor: red[500], color: "white", fontSize: "1rem" };
const rtrn = { backgroundColor: grey[500], color: "white", fontSize: "1rem" };

///////////// socket.io //////////////
const socket = createChatSocket();
///////////// socket.io //////////////

export default function StateChgPopover(props) {
  ///////////// socket.io //////////////
  // useEffect(() => {
  //   console.log("socket.on useEffect")
  //   socket.on("stsync", (data) => {  // 소켓서버에서 보낸 자료를 받음
  //     const { name, msg, time } = data;
  //     console.log(+new Date()+" : "+name+" : "+msg+" : "+time);
  //     // const { name, msg, time } = data;
  //     // const item = new LiModel(name, msg, time);
  //     // item.makeLi();
  //     alert(+new Date()+" : "+name+" : "+msg+" : "+time );
  //   });
  // }, []);

  const sendsync = (sort, org, eqp, csgn, snum, mfstatus) => {
    // 소캣서버로 갱신변경 자료를 보냄
    const nowdt = new Date();
    const yy = nowdt.getFullYear();
    const mm = nowdt.getMonth() + 1;
    const dd = nowdt.getDate();
    const hh = nowdt.getHours();
    const mi = nowdt.getMinutes();
    const nowdtstr = `${yy}.${mm}.${dd} ${hh}:${mi}`;
    const param = {
      sort: sort,
      inputuser: sessionStorage.mfmid,
      dsid: sessionStorage.selectedDSid.trim(),
      org: org,
      eqp: eqp,
      csgn: csgn,
      snum: snum,       // 변경된 자원 ID (실시간 행 업데이트용)
      mfstatus: mfstatus, // 새 상태값 (실시간 행 업데이트용)
      transtxt: `${nowdtstr} ${org} ${csgn.trim()} ${
        sessionStorage.selectedFromState
      } -> ${sessionStorage.selectedToState} 변경`,
      selectedEqp: sessionStorage.selectedEqp,
      selectedOrg: sessionStorage.selectedOrg,
    };
    console.log(param);
    socket.emit("stsync", param);
  };
  ///////////// socket.io //////////////

  //console.log(props.onStatus)
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    sessionStorage.selectedFromState = event.currentTarget.textContent;
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  //////////////  스낵바 호출 //////////////
  const [sbShow, setSbShow] = useState("");
  const callSnakbar = (msg, sort) => {
    // const msg = "삭제되었습니sdfsdfsd다.";
    // const sort = "warning" // info, success, warning, error
    setSbShow(+new Date() + "^" + msg + "^" + sort);
  };
  //////////////  스낵바 호출 //////////////

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  const wstat = props.status == 0;
  const mstat = props.status == 1;
  const astat = props.status == 2;
  const rstat = props.status == 3;
  const sstat = props.status == 9;

  const stateChageHandler = (e) => {
    const btn = e.currentTarget;
    const toText = (btn && (btn.dataset.label || btn.textContent)) ? (btn.dataset.label || btn.textContent).trim() : "";
    sessionStorage.selectedToState = toText;

    let eqp = (e.target.name || btn.name || "").split("^")[0];
    eqp = eqp.trim().replace("소방", "");
    const nameStr = e.target.name || btn.name || "";
    let org = nameStr.split("^")[1];
    let csgn = nameStr.split("^")[2];
    org = org.trim();
    org = org.replace(/본부|소방|안전|구조|재난|상|라|청|도/g, "");
    console.log(eqp, org);

    if (
      window.confirm(toText + "으로 수정하시겠습니까? ") == false
    )
      return handleClose();
    const dsid = sessionStorage.selectedDSid;
    const id = props.id; // e.target.id 대신 props.id 사용 (MUI ripple span 클릭 시 e.target.id가 빈 문자열이 되는 문제 방지)
    // 집결중=9, 대기중=0, 이동중=1, 활동중=2, 원대복귀=3 (DB/사인보드와 일치) — data-status 우선 사용
    const statusFromData = btn && btn.dataset.status != null ? parseInt(btn.dataset.status, 10) : NaN;
    const status =
      !isNaN(statusFromData)
        ? statusFromData
        : toText === "집결중"
        ? 9
        : toText === "대기중"
        ? 0
        : toText === "이동중"
        ? 1
        : toText === "활동중"
        ? 2
        : toText === "원대복귀"
        ? 3
        : 3;
    console.log("[StateChg] id:", id, "toText:", toText, "status:", status);

    async function changestatus() {
      const wstring = `${props.apiAddr}/post/changestatus`;
      const statData = {
        dsid: (sessionStorage.selectedDSid || "").trim(),
        snum: id,
        nowstat: status,
        glat: "",
        glon: "",
        gacc: "",
        gtme: "",
      };
      console.log(wstring, statData);
      try {
      const response = await axios.post(wstring, statData);
      const result = response.data.result;
      if (result === "success") {
        const dsidVal = (sessionStorage.selectedDSid || "").trim();
        console.log("[StateChgPopover] changestatus 성공", { id, status, dsid: dsidVal });
        callSnakbar("수정되었습니다.", "success");
        if (typeof window.dispatchEvent === "function") {
          const toShort = (s) => (s || "").replace("원대복귀", "복귀").replace("중", "");
          const fromState = toShort(sessionStorage.selectedFromState);
          const toState = toShort(sessionStorage.selectedToState);
          const now = new Date();
          const ipdt = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")} ${String(now.getHours()).padStart(2, "0")}:${String(now.getMinutes()).padStart(2, "0")}:${String(now.getSeconds()).padStart(2, "0")}`;
          window.dispatchEvent(new CustomEvent("mfHistoryRowAdded", {
            detail: {
              dsid: sessionStorage.selectedDSid || "",
              row: {
                mf_snum: parseInt(id, 10),
                kind: "status",
                mfeqp: eqp,
                mfdorg: org,
                mfcsgn: csgn,
                content: `${fromState || "?"}->${toState || "?"}`,
                ipdt,
              },
            },
          }));
        }
        // 동원자원앱과 동일: Home stsync 수신 시 dsid 비교용 ondsid 동기화
        sessionStorage.ondsid = dsidVal;
        console.log("[StateChgPopover] stsync 전송 (stateChaged)", { dsid: dsidVal, snum: id, mfstatus: status });
        sendsync("stateChaged", org, eqp, csgn, id, status);
        sessionStorage.selectedFromState = sessionStorage.selectedToState;
        if (typeof window.dispatchEvent === "function") {
          window.dispatchEvent(new CustomEvent("mfStatusChanged", {
            detail: { dsid: dsidVal, snum: id, mfstatus: status },
          }));
          console.log("[StateChgPopover] mfSignboardRefresh 디스패치");
          window.dispatchEvent(new CustomEvent("mfSignboardRefresh"));
        }
        props.callRefreshList?.();
      } else {
        console.warn("[StateChgPopover] changestatus 실패", { result });
        callSnakbar("수정에 실패했습니다.", "error");
      }
      } catch (err) {
        console.warn("[StateChgPopover] changestatus 실패", { message: err?.message || err });
        callSnakbar("수정에 실패했습니다.", "error");
      }
    }
    changestatus();
    handleClose();
  };

  return (
    <div>
      <Snackbar sbShow={sbShow} />
      {sstat && (
        <Button sx={strt} onClick={handleClick}>
          집결중
        </Button>
      )}
      {wstat && (
        <Button sx={wait} onClick={handleClick}>
          대기중
        </Button>
      )}
      {mstat && (
        <Button sx={move} onClick={handleClick}>
          이동중
        </Button>
      )}
      {astat && (
        <Button sx={actv} onClick={handleClick}>
          활동중
        </Button>
      )}
      {rstat && (
        <Button sx={rtrn} onClick={handleClick}>
          원대복귀
        </Button>
      )}
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <Box
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            margin: "0 2px 0 2px",
          }}
        >
          <Box sx={{ p: 1 }} gap={3}>
            {!sstat && (
              <Button
                id={props.id}
                name={props.eqp + "^" + props.org + "^" + props.csgn}
                data-label="집결중"
                data-status="9"
                sx={strt}
                style={{ margin: "0 3px" }}
                onClick={stateChageHandler}
              >
                집결중
              </Button>
            )}
            {!wstat && (
              <Button
                id={props.id}
                name={props.eqp + "^" + props.org + "^" + props.csgn}
                data-label="대기중"
                data-status="0"
                sx={wait}
                style={{ margin: "0 3px" }}
                onClick={stateChageHandler}
              >
                대기중
              </Button>
            )}
            {!mstat && (
              <Button
                id={props.id}
                name={props.eqp + "^" + props.org + "^" + props.csgn}
                data-label="이동중"
                data-status="1"
                sx={move}
                style={{ margin: "0 3px" }}
                onClick={stateChageHandler}
              >
                이동중
              </Button>
            )}
            {!astat && (
              <Button
                id={props.id}
                name={props.eqp + "^" + props.org + "^" + props.csgn}
                data-label="활동중"
                data-status="2"
                sx={actv}
                style={{ margin: "0 3px" }}
                onClick={stateChageHandler}
              >
                활동중
              </Button>
            )}
            {!rstat && (
              <Button
                id={props.id}
                name={props.eqp + "^" + props.org + "^" + props.csgn}
                data-label="원대복귀"
                data-status="3"
                sx={rtrn}
                style={{ margin: "0 3px" }}
                onClick={stateChageHandler}
              >
                원대복귀
              </Button>
            )}
          </Box>
        </Box>
      </Popover>
    </div>
  );
}
